module.exports = __webpack_public_path__ + "static/media/img-e1c25a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/membershealth-logo.png
// module id = 5294
// module chunks = 39